'use client'

import { LoadingButton } from '@/components/loading-button'
import {
  EMAIL_FIELD_NAME,
  EmailMessagingStatus,
} from '@/modules/auth/constants'
import { useForm, FormProvider } from 'react-hook-form'
import { EmailField } from '@/modules/forms/common/email-field'
import { EMAIL_ERROR_FIELD } from '@/modules/forms/common/constants'
import {
  EmailFieldStatus,
  useEmailFieldStore,
} from '@/modules/forms/common/email-field-store'
import { usePostHog } from 'posthog-js/react'

export function SignInFields({
  children,
  title,
  isSignIn = false,
}: {
  children?: React.ReactNode
  title: string
  isSignIn?: boolean
}) {
  const form = useForm<{ email: string; EMAIL_ERROR_FIELD: string }>({
    defaultValues: {
      [EMAIL_FIELD_NAME]: '',
      [EMAIL_ERROR_FIELD]: '',
    },
  })
  const posthog = usePostHog()
  const { getValues, trigger, clearErrors, formState } = form
  const { errors } = formState
  const emailErrors = errors[EMAIL_FIELD_NAME] || errors[EMAIL_ERROR_FIELD]
  const emailFieldStatus = useEmailFieldStore((state) => state.emailFieldStatus)
  const emailVerificationStatus = useEmailFieldStore(
    (state) => state.emailVerificationStatus,
  )

  return (
    <FormProvider {...form}>
      <EmailField
        fieldName={EMAIL_FIELD_NAME}
        label="Email"
        placeholder="Enter email"
        allowList={['@marithealth.com']}
        onValidateEmail={(opts) => {
          const emailResult = opts.data.validateEmail.result
          if (
            emailResult === EmailMessagingStatus.unknown ||
            emailResult === EmailMessagingStatus.risky
          ) {
            posthog.capture('email_verification', {
              email_text: getValues(EMAIL_FIELD_NAME),
              verification_status: emailResult,
              action: 'typing',
              type: isSignIn ? 'signin' : 'signup',
            })
          }
        }}
      />
      {children}
      <LoadingButton
        className="my-4 w-full"
        size="lg"
        type="submit"
        onClick={(event) => {
          const email = getValues(EMAIL_FIELD_NAME)
          // cannot use handleSubmit because it will prevent default
          posthog.capture('email_verification', {
            email_text: email,
            verification_status: emailVerificationStatus,
            action: 'submit',
            type: isSignIn ? 'signin' : 'signup',
          })

          if (
            !getValues(EMAIL_FIELD_NAME) ||
            emailFieldStatus !== EmailFieldStatus.Called
          ) {
            trigger()
            event?.preventDefault()
            return
          }
          if (emailErrors) {
            trigger()
            event?.preventDefault()
            return
          }
          clearErrors()
        }}
      >
        {title}
      </LoadingButton>
    </FormProvider>
  )
}
